import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{html-safe @string}}",{ moduleName: "discourse/components/search-menu/highlighted-search.hbs" })